import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import {appSetModalContent} from "../../../../redux/app/appActions";
import {dataRemoveFilter} from "../../../../redux/data/dataActions";
import {pageComponentConfigurationAction} from "../../../../redux/page/pageActions";
import {PAGE_COMPONENT_EDIT} from "../../../../redux/page/pageTypes";
import {findXConfigSchema} from "./findXConfigSchema";

import _ from "lodash";
import {useForm} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import TextFieldsIcon from '@mui/icons-material/TextFields';

import {
    styled,
    InputAdornment,
    Input,
    FormControl,
    InputLabel,
    DialogActions,
    Button,
} from '@mui/material';



const PREFIX = 'SettingsForm';

const classes = {
    form: `${PREFIX}-form`,
    formEmbeddedActions: `${PREFIX}-formEmbeddedActions`,
    padding: `${PREFIX}-padding`,
    margin: `${PREFIX}-margin`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.form}`]: {
		height: '460px',
		overflow: 'auto'
	},

    [`& .${classes.formEmbeddedActions}`]: {
		// position: 'absolute',
		// bottom: '0px',
		// height: '120px',
		// width: 'calc(100% - 32px)'
	},

    [`& .${classes.padding}`]: {
		padding: theme.spacing(1)
	},

    [`& .${classes.margin}`]: {
		// margin: '8px', // theme.spacing(1),
		width: 'calc(100% - 8px)'
	}
}));

// http://webcache.googleusercontent.com/search?q=cache:https://www.botsplash.com/post/convert-your-json-to-forms-in-react
export default function SettingsForm({pageID, xId, configuration, schemaType, placeholders}) {

	const dispatch = useDispatch();

	// App State
	const filters = useSelector(state => state.data.filters);

	// Component State
	const [page, setPage] = useState(pageID);

	// console.log(configuration);

	// Setup Form Validation
	const createYupSchema = (schema, config) => {
		// https://stackoverflow.com/questions/56725383/create-dynamic-yup-validation-schema-from-json
		// https://codesandbox.io/s/clever-snyder-1u410?fontsize=14

		const { id, validationType, validations = [] } = config;
		if (!yup[validationType]) {
			return schema;
		}
		let validator = yup[validationType]();
		validations.forEach(validation => {
			const { params, type } = validation;
			if (!validator[type]) {
				return;
			}
			// console.log(type, params);
			validator = validator[type](...params);
		});
		schema[id] = validator;
		return schema;
	}

	// Obtain xConfig schema to build the respective xConfig form
	const componentSchema = findXConfigSchema(configuration, schemaType);
	let schema = componentSchema.schema;
	let tabs = componentSchema.tabs;

	// Build out xConfig schema
	let newSchema = [];
	switch(schemaType.toLowerCase()) {
		case 'tab':
			for (let i = 0; i < tabs.length; i++) {
				let tempSchema = {};
				tempSchema = schema.find((f) => {return f.id === "label"});
				tempSchema = {
					...tempSchema,
					id: "label" + i,
					placeholder: tabs[i].label
				}
				newSchema.push(tempSchema);
			}
			// setFinalSchema(newSchema);
			break;
		default:
			newSchema = schema;
			// setFinalSchema(schema);
	}
	const fieldNames =  newSchema.map((field, i) => {
		return field.id
	});

	// Create YupSchema, Yup Shape Object, and Yup Resolver
	const yepSchema = newSchema.reduce(createYupSchema, {});
	const validateSchema = yup.object().shape(yepSchema);
	const resolver = yupResolver(validateSchema);

	// Form
	const { register, handleSubmit, formState, formState: { errors } } = useForm({resolver});


	// Functions to dynamically build Input elements:
	// --> Text Input
	const TextInputField = ({ schemaField, placeholder, value }) => (
		<FormControl className={classes.margin}>
			<InputLabel>{schemaField.label}</InputLabel>
			<Input
				{...register(schemaField.id)}
				id={schemaField.id}
				name={schemaField.id}
				startAdornment={
					<InputAdornment position="start">
						<TextFieldsIcon/>
					</InputAdornment>
				}
				inputProps={{
					"aria-label": schemaField.id
				}}
				disabled={schemaField.disabled}
				defaultValue={placeholder}
			/>
			{errors[schemaField.id] && <p style={{color: 'red'}}>{errors[schemaField.id]?.message}</p>}
		</FormControl>
	);

	// // --> Radio and Select Input options
	// const getSchemaFieldOptions = (schema, field) => (
	// 	schema[field].options.map(option => {
	// 		let label = option;
	// 		let value = option;
	//
	// 		if (Array.isArray(option)) {
	// 			value = option[0];
	// 			label = option[1] || option[0];
	// 		}
	// 		return { value, label };
	// 	})
	// )
	//
	// // --> Radio Input
	// const RadioField = ({ name, fieldOptions }) => (
	// 	<Field name={name}>
	// 		{({ input, meta }) => (
	// 			<div>
	// 				{fieldOptions.map(option => (
	// 					<React.Fragment key={option.value}>
	// 						<input
	// 							{...input}
	// 							type="radio"
	// 							id={option.value}
	// 							value={option.value}
	// 							checked={ input.value === option.value }
	// 							onChange={e => input.onChange(e.target.value)}
	// 						/>
	// 						<label htmlFor={option.value}>{option.label}</label>
	// 						{meta.error && meta.touched &&
	// 							<div className="final-error">{meta.error}</div>
	// 						}
	// 					</React.Fragment>
	// 				))}
	// 			</div>
	// 		)}
	// 	</Field>
	// )
	//
	// // --> Select Input
	// const SelectField = ({ name, placeholder, fieldOptions }) => (
	// 	<Field name={name}>
	// 		{({ input, meta }) => (
	// 			<div>
	// 				<select {...input}>
	// 					<option value="">
	// 						{placeholder || '--Select an option--'}
	// 					</option>
	// 					{fieldOptions.map(option => (
	// 						<option key={option.value} value={option.value}>
	// 							{option.label}
	// 						</option>
	// 					))}
	// 				</select>
	// 				{meta.error && meta.touched &&
	// 					<div className="final-error">{meta.error}</div>
	// 				}
	// 			</div>
	// 		)}
	// 	</Field>
	// )

	const onSubmit = (data) => {
		// console.log(data);

		const clonedConfig = _.cloneDeep(configuration);


		let newConfig = {};
		switch(schemaType.toLowerCase()) {
			case 'tab':
				newConfig = {
					tabs: []
				};

				// Modify Tab Labels
				for (let i = 0; i < newSchema.length; i++) {
					const tabLabel = "label" + i;
					if (newSchema[i].id === tabLabel) {
						newConfig.tabs[i] = clonedConfig.tabs[i];
						newConfig.tabs[i].label = data[tabLabel];
					}
				}

				clonedConfig.tabs = _.merge(clonedConfig.tabs, newConfig.tabs);
				break;
			default:
				newConfig = {
					name: {}
				};
				newConfig.name.title = data['title'] !== undefined ? data['title'] : '';
				newConfig.name.subtitle = data['subtitle'] !== undefined ? data['subtitle'] : '';

				clonedConfig.name = _.merge(clonedConfig.name, newConfig.name);
		}

		// console.log(clonedConfig);
		dispatch(pageComponentConfigurationAction(page, xId, clonedConfig));

		handleClose();
	}

	const getSchemaElement = (schema, field) => {

		const schemaField = schema.find((f) => {return f.id === field});

		if (schemaField) {
			switch (schemaField.element) {
				// case 'radio':
				// 	return (
				// 		<RadioField
				// 			name={field}
				// 			fieldOptions={getSchemaFieldOptions(schema, field)}
				// 		/>
				// 	);
				//
				// case 'select':
				// 	return (
				// 		<SelectField
				// 			name={field}
				// 			fieldOptions={getSchemaFieldOptions(schema, field)}
				// 			placeholder={schema[field].placeholder}
				// 		/>
				// 	);

				default:
				case 'text':
					return (
						<TextInputField
							schemaField={schemaField}
							placeholder={field in placeholders ? placeholders[field] : schemaField.placeholder}
						/>
					);
			}
		}
	}

	const handleClose = () => {
		dispatch(appSetModalContent(null));

		// -412 represents a filter applied for a click that produces a Modal (FormatUtilities.js --> FormatModalLink)
		const filterModalExists = filters.find(f => {
			return f.id.toLowerCase() === "-412"
		});
		if (filterModalExists) {
			// Remove the filter for modal because the user's intent is to get more data, not filter the app
			dispatch(dataRemoveFilter("-412"));
		}

		// Modal closed, clear out editXId value because new values triggers Modal to open
		dispatch({
			type: PAGE_COMPONENT_EDIT,
			payload: {
				xId: null,
				xIdHint: null
			}
		});
	};

	return (
        <Root>
			{newSchema && fieldNames &&
				<form className={classes.form} onSubmit={handleSubmit(onSubmit)}>

					{fieldNames.map((field, i) => (
						<div key={i} className={classes.padding}>
							{
								getSchemaElement(newSchema, field)
							}
						</div>
					))}

					<DialogActions className={classes.formEmbeddedActions}>
						<Button onClick={handleClose} color="primary" disabled={formState.isSubmitting}>
							Cancel
						</Button>
						<Button color="primary" type="submit" disabled={formState.isSubmitting}>
							Submit
						</Button>
					</DialogActions>
				</form>
			}
		</Root>
    );
}